const DeleteIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17.607 19.875">
            <g id="delete_file" transform="translate(0.5)">
                <g id="Group_7155" data-name="Group 7155">
                    <path
                        id="Path_3240"
                        data-name="Path 3240"
                        d="M11,1.845V.615A.615.615,0,0,1,11.615,0h2.46a.615.615,0,0,1,.615.615v1.23Z"
                        transform="translate(-4.542)"
                        fill="#1650b4"
                    />
                    <path
                        id="Path_3241"
                        data-name="Path 3241"
                        d="M1.73,4.345H16.492a.615.615,0,0,0,.615-.615V3.115a.615.615,0,0,0-.615-.615H1.115A.615.615,0,0,0,.5,3.115V3.73a.615.615,0,0,0,.615.615Zm0,0L2.873,19.2A1.23,1.23,0,0,0,4.1,20.337h9.408A1.23,1.23,0,0,0,14.734,19.2L15.877,4.345"
                        transform="translate(-0.5 -0.962)"
                        fill="#f0f3f7"
                        stroke="#0c3b8d"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_3242"
                        data-name="Path 3242"
                        d="M7.552,19.879,6.891,8.5M9.947,19.879,9.726,8.5M12.58,19.879,12.8,8.5m2.174,11.379L15.637,8.5"
                        transform="translate(-2.96 -3.272)"
                        fill="#f0f3f7"
                        stroke="#1650b4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                </g>
            </g>
        </svg>
    );
};

export default DeleteIcon;
